<template>
  <div class="unBinding-account-page">
    <div class="header-btn" v-if="unBindingCom" @click="unBindingCom = !unBindingCom">
      <img src="../../assets/img/components/wechatBinding/icon_close.png" alt="关闭" />
    </div>
    <template v-if="unBindingCom">
      <div class="title">账号解绑</div>
      <div class="tips">为了保证您的账号安全，请输入已绑定的手机号码用来解除绑定</div>
      <div class="content">
        <van-form
          ref="form"
          @submit="onSubmit"
          @failed="onFailed"
          :show-error="false"
          :show-error-message="false"
        >
          <div class="form-list-item">
            <div class="item-content">
              <van-field
                v-model="phone"
                name="phone"
                placeholder="请输入解绑的手机号码"
                @input="fieldInput"
                :rules="[
                  { required: true, pattern: phonePattern, message: '手机号码错误，请重新输入' },
                ]"
              />
            </div>
          </div>

          <div class="footer">
            <div
              class="form-btn"
              :class="btnActivity ? '' : 'no-activity-btn'"
              @click="submitClick"
            >
              解除绑定
            </div>
          </div>
        </van-form>
      </div>
    </template>
    <template v-else>
      <div class="title">账号绑定</div>
      <div class="binding-content">
        <div class="binding-content-title">当前绑定账号为</div>
        <div class="binding-content-phone">{{ phoneEncryption(bindingInfo.phone) }}</div>
      </div>
      <div class="footer">
        <div class="form-btn" @click="unBindingCom = !unBindingCom">解除绑定</div>
        <div class="form-msg">我们将会查询已绑定手机号下的直播课程 并在开播前15分钟提醒您</div>
      </div>
    </template>
    <toast ref="toast" />
  </div>
</template>

<script>
import { getWechatAppId } from '@/utils/tools';
// eslint-disable-next-line import/extensions
import toast from '@/components/wxchatBinding/toast';
import { reqCancelWeChatBind } from '@/api/wechatServiceNum';

export default {
  components: { toast },
  props: ['bindingInfo'],
  data() {
    return {
      phone: '',
      smsCode: '',
      wxInfo: {},
      phonePattern: /^\d{11}$/,
      smsCodePattern: /^\d{4}$/,
      timer: null,
      smsCodeCount: 60,
      isSmsCodeBtnActive: true,
      unBindingCom: false,
      btnActivity: false,
      toastShow: false,
    };
  },
  mounted() {
    if (this.$route.query.state && this.$route.query.state === 'weixinredirect') {
      this.wxInfo = this.$route.query;
    }
  },
  methods: {
    // 手机号码替换中间数字
    phoneEncryption(val) {
      if (!val) {
        return '';
      }
      const phone = `${val}`;
      return `${phone.substr(0, 3)}****${phone.substr(7)}`;
    },

    // 表单输入验证正则改变按钮状态
    fieldInput() {
      this.$refs.form
        .validate()
        .then(() => {
          this.btnActivity = true;
        })
        .catch(() => {
          this.btnActivity = false;
        });
    },

    submitClick() {
      this.$refs.form.submit();
    },

    async onSubmit(values) {
      const wechatAppId = await getWechatAppId('binding');
      if (!this.btnActivity) {
        return;
      }
      this.btnActivity = false;
      const param = {
        appId: wechatAppId,
        code: this.wxInfo.code,
        phone: values.phone,
      };
      const response = await reqCancelWeChatBind(param);
      if (response.code === 0) {
        this.$refs.toast.toastShow({
          type: 'success',
          text: '账号已解除绑定',
        });
        setTimeout(() => {
          this.btnActivity = true;
          // 解绑成功跳转绑定页面
          this.$parent.wechatAuth();
        }, 1000);
      } else if (response.code === 6061) {
        // 微信code失效
        this.$toast('页面停留时间长');
        setTimeout(() => {
          this.btnActivity = true;
          this.$parent.wechatAuth();
        }, 1000);
      } else {
        this.btnActivity = true;
        this.$toast(response.msg);
      }
    },

    onFailed(val) {
      this.$refs.toast.toastShow({
        type: 'warn',
        text: val.errors[0].message,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.unBinding-account-page {
  margin: 0 64px;
  overflow: auto;

  .header-btn {
    position: fixed;
    top: 34px;
    left: 34px;

    img {
      width: 48px;
      height: 48px;
    }
  }

  .title {
    margin-top: 200px;
    color: #313131;
    font-weight: bold;
    font-size: 40px;
    line-height: 56px;
  }

  .tips {
    margin-top: 16px;
    color: #303030;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
  }

  .content {
    margin-top: 120px;

    ::v-deep .van-cell {
      background: rgba(0, 0, 0, 0);

      &::after {
        border: 0;
      }
    }

    .form-list-item {
      display: flex;
      justify-content: space-between;

      .item-title {
        color: #313131;
        font-weight: 400;
        font-size: 28px;
        line-height: 72px;
        white-space: nowrap;
      }

      .item-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 495px;
        border-bottom: 2px solid #f5f5f5;
      }

      .get-smsCode-btn {
        height: 48px;
        padding: 8px 16px;
        color: #ff8100;
        font-weight: 400;
        font-size: 24px;
        line-height: 32px;
        white-space: nowrap;
        border: 2px solid #ff8100;
        border-radius: 8px;
      }

      .no-active-btn {
        color: #787878;
        border-color: #787878;
      }
    }
  }

  .binding-content {
    margin-top: 80px;
    padding-bottom: 80px;

    .binding-content-title {
      color: #303030;
      font-weight: 400;
      font-size: 24px;
      line-height: 32px;
    }

    .binding-content-phone {
      margin-top: 16px;
      color: #303030;
      font-weight: 500;
      font-size: 48px;
      line-height: 48px;
    }
  }

  .footer {
    margin-top: 120px;
    overflow: hidden;

    .form-btn {
      height: 88px;
      color: white;
      font-size: 32px;
      line-height: 88px;
      text-align: center;
      background: #ff8100;
      border-radius: 12px;
    }
    .form-msg {
      width: 441px;
      margin: 26px auto;
      color: #787878;
      font-weight: 400;
      font-size: 24px;
      line-height: 34px;
      text-align: center;
    }
    .no-activity-btn {
      background: #fdd8b5;
    }
  }
}
</style>
<style lang="scss">
.binding-account-page {
  input {
    font-size: 28px;
  }
}
</style>
